module.exports = __webpack_public_path__ + "img/20190917173545523.a5eb7a22.jpg";